export default __webpack_public_path__ + "static/media/Risk_Disclosure.369984b4.pdf";